import { ChampionshipSettings } from 'modules/championship/domain/interfaces/championship-settings';
import { PeriodsByMatchChronology } from 'shared/types/PeriodsByMatchChronology';

// Generates periods map based on ChampionshipSettings per spec.
// Keys start from 1 for main periods, then extra periods, plus mandatory key 0.
export const generatePeriodsBySettings = (settings: ChampionshipSettings): { [key: number]: PeriodsByMatchChronology } => {
  const isGamePeriodsValid = settings.gamePeriodsNumber && settings.gamePeriodsNumber > 0;
  const isPeriodTimeValid = settings.periodTime && settings.periodTime > 0;
  if (!isGamePeriodsValid || !isPeriodTimeValid) {
    throw Error('gamePeriodsNumber or periodTime is 0 or null, it must be set in the settings');
  }

  const mainCount = settings.gamePeriodsNumber ?? 0;
  const extraCount = settings.gameExtraPeriodsNumber ?? 0;
  const mainDuration = settings.periodTime ?? 0;
  const extraDuration = settings.periodExtraTime ?? 0;

  const result: { [key: number]: PeriodsByMatchChronology } = {};

  let currentStart = 0;

  // Main periods
  for (let i = 1; i <= mainCount; i += 1) {
    const finish = currentStart + mainDuration;
    result[i] = {
      duration: mainDuration,
      startMinute: currentStart,
      finishMinute: finish,
      isMain: true,
    };
    currentStart = finish;
  }

  // Extra periods
  for (let j = 1; j <= extraCount; j += 1) {
    const index = mainCount + j;
    const finish = currentStart + extraDuration;
    result[index] = {
      duration: extraDuration,
      startMinute: currentStart,
      finishMinute: finish,
      isMain: false,
    };
    currentStart = finish;
  }

  // Mandatory key 0
  result[0] = {
    duration: 2000,
    startMinute: 0,
    finishMinute: 2000,
    isMain: false,
  };

  return result;
};
